import { publicUrlFor } from "../../../globals/constants";
import {useRef, useState} from "react";
import {toast} from 'react-hot-toast';
import axios from "axios";
import {gtagConversion, trackPhoneClick} from "../../../lib/gtag";
import {track, useFormTracking} from "../../../lib/analytics";
import {useLocation, useNavigate} from "react-router-dom";

export default function ContactPage() {

    const navigate = useNavigate();
    const {pathname} = useLocation();

    // A Google Ads landing oldalakrol erkezonek mar ki van valasztva a
    // megfelelo szolgaltatas - eggyel kevesebb kattintas az ajanlatkeresig.
    const SERVICE_BY_PATH = {
        "/koltoztetes-budapest": "Költöztetés",
        "/lomtalanitas-budapest": "Lomtalanítás"
    };
    const defaultService = SERVICE_BY_PATH[pathname] || "";

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
        service: defaultService,
        from: "",
        to: "",
        floor: "",
        elevator: "",
        area: "",
        parking: "",
        boxes: "",
        referred_by: "",
        terms_and_conditions: false,
    });

    const [captchaValue, setCaptchaValue] = useState(true);
    const recaptchaRef = useRef(null);
    const formTracking = useFormTracking("arajanlat");

    const handleChange = (e) => {
        const {name, value} = e.target;
        formTracking.field(name, value !== "");
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validate = () => {

        // hibas mezo naplozasa + a megszokott toast
        const fail = (field, message) => {
            formTracking.error(field, message);
            toast.error(message);
            return false;
        };

        const email = (formData.email || "").trim();
        const phone = (formData.phone || "").trim();

        // Elerhetoseg: eleg az egyik, de legalabb az egyik kell - kulonben
        // nem tudnank visszajelezni az ajanlattal.
        if (!email && !phone) {
            return fail("contact", 'Kérjük, adja meg az e-mail címét vagy a telefonszámát');
        }

        // Amit megadott, az legyen ervenyes
        if (email) {
            let pattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
            if (!pattern.test(email)) {
                return fail("email", 'Az email formátuma nem megfelelő');
            }
        }

        if (phone && (phone.match(/\d/g) || []).length < 7) {
            return fail("phone", 'A telefonszám formátuma nem megfelelő');
        }

        // A tobbi mezo opcionalis: minel kevesebbet kell kitolteni,
        // annal tobb ajanlatkeres erkezik be.

        if (!formData.terms_and_conditions) {
            return fail("terms_and_conditions", 'Az Általános Szerződési Feltételeket és az Adatvédelmi Szabályzatot el kell fogadnia');
        }

        return true;
    };

    async function handleSubmit(e) {
        e.preventDefault();

        formTracking.start();
        track("form_submit_attempt", {form_name: "arajanlat"});

        if (validate()) {

            const url = process.env.REACT_APP_API_URL;

            const failed = (reason) => {
                formTracking.submitError(reason);
                toast.error('A küldés nem sikerült, kérjük próbálja újra, vagy hívjon minket telefonon!', {
                    position: "bottom-center"
                })
                return {};
            };

            let response;
            try {
                response = await axios.post(`${url}/api/send-email`, formData);
            } catch (error) {
                return failed(error?.message || "halozati hiba");
            }

            // A 2xx onmagaban nem eleg: ha a backend kimondottan sikertelensegre
            // jelez vissza, az nem lead. Az API "status"-t hasznal, de a
            // "success"-re is felkeszulunk. Ha egyik sincs, a 2xx a siker.
            if (response?.data?.success === false || response?.data?.status === false) {
                return failed(response?.data?.message || "a backend sikertelenseget jelzett");
            }

            // Innentol biztosan sikeres: form_submit + generate_lead
            formTracking.submit();

            gtagConversion("conversion", {
                send_to: "AW-17491861595/7pR7CPnb244bENvA4pRB",
            });

            toast.success('Köszönjük levelét, munkatársunk hamarosan felveszi önnel a kapcsolatot!', {
                position: "bottom-center"
            })

            navigate("/koszonjuk");

            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }
            setFormData({
                name: "",
                email: "",
                message: "",
                service: defaultService,
                from: "",
                to: "",
                floor: "",
                elevator: "",
                area: "",
                parking: "",
                boxes: "",
                referred_by: "",
                terms_and_conditions: false,
            });
        }

        return {};
    };

    const onCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleClickPhone = (phone) => {
        trackPhoneClick('AW-17491861595/GmBFCJ-yi5AbENvA4pRB', phone);
    };

    return (
        <>
            <div className="section-full">
                <div className="section-content">
                    <div className="container">
                        <div className="contact-one">
                            {/* TITLE START*/}
                            <h2 className="comment-reply-title section-head-small mb-4" id="reply-title">Árajánlat
                            </h2>
                            {/* TITLE END*/}
                            {/* CONTACT FORM*/}
                            <div className="contact-one-inner  site-bg-sky-blue-light">
                                <div className="row">
                                    <div className="col-lg-8 col-md-12">
                                        <div className="contact-form-outer">
                                            <form className="cons-contact-form"
                                                  onFocus={() => formTracking.start()}>
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="name"
                                                                   className="form-label">Adatok</label>
                                                            <input name="name"
                                                                   id="name"
                                                                   type="text"
                                                                   className="form-control"
                                                                   value={formData.name}
                                                                   onChange={handleChange}
                                                                   placeholder="Név"/>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="email"
                                                                   className="form-label invisible">Cím</label>
                                                            <input name="email" type="text" className="form-control"
                                                                   placeholder="Email"
                                                                   id="email"
                                                                   value={formData.email}
                                                                   onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="phone"
                                                                   className="form-label invisible">Cím</label>
                                                            <input name="phone" type="text" className="form-control"
                                                                   placeholder="Telefonszám"
                                                                   id="phone"
                                                                   value={formData.phone}
                                                                   onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <p style={{
                                                            marginTop: '-8px',
                                                            marginBottom: '16px',
                                                            fontSize: '13px',
                                                            color: '#777'
                                                        }}>
                                                            Az e-mail cím vagy a telefonszám megadása kötelező, a
                                                            többi mező kitöltése nem. Minél több adatot ad meg,
                                                            annál pontosabb árajánlatot tudunk küldeni.
                                                        </p>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="service"
                                                                   className="form-label">Milyen szolgáltatást
                                                                kér?</label>
                                                            <select
                                                              name="service"
                                                              id="service"
                                                              className="form-control"
                                                              value={formData.service}
                                                              onChange={handleChange}
                                                            >
                                                                <option value="">Válassz</option>
                                                                <option value="Költöztetés">Költöztetés</option>
                                                                <option value="Bútorszállítás">Bútorszállítás</option>
                                                                <option value="Lomtalanítás">Lomtalanítás</option>
                                                                <option value="TeherTaxi">TeherTaxi</option>
                                                                <option value="Áruszállítás">Áruszállítás</option>
                                                                <option value="Egyéb">Egyéb</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="from"
                                                                   className="form-label">Cím</label>
                                                            <input name="from" type="text" className="form-control"
                                                                   placeholder="Honnan (cím)"
                                                                   id="from"
                                                                   value={formData.from}
                                                                   onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="from"
                                                                   className="form-label invisible">Cím</label>
                                                            <input name="to" type="text" className="form-control"
                                                                   placeholder="Hova (cím)"
                                                                   id="to"
                                                                   value={formData.to}
                                                                   onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="from"
                                                                   className="form-label">Dátum</label>
                                                            <input name="date"
                                                                   type="date"
                                                                   className="form-control"
                                                                   placeholder="2025-10-01"
                                                                   id="date"
                                                                   value={formData.when}
                                                                   onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="floor"
                                                                   className="form-label">Emeletek száma</label>
                                                            <select
                                                              name="floor"
                                                              className="form-control"
                                                              value={formData.floor}
                                                              onChange={handleChange}
                                                            >
                                                                <option disabled value="">Válassz</option>
                                                                <option value="Földszint">Földszint</option>
                                                                <option value="1 emelet">1 emelet</option>
                                                                <option value="2 emelet">2 emelet</option>
                                                                <option value="3 emelet">3 emelet</option>
                                                                <option value="4 emelet">4 emelet</option>
                                                                <option value="5 emelet">5 emelet</option>
                                                                <option value="6 emelet">6 emelet</option>
                                                                <option value="7 emelet">7 emelet</option>
                                                                <option value="8 emelet">8 emelet</option>
                                                                <option value="9 emelet">9 emelet</option>
                                                                <option value="10 emelet">10 emelet</option>

                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="elevator"
                                                                   className="form-label">Lift</label>
                                                            <select
                                                              name="elevator"
                                                              className="form-control"
                                                              value={formData.elevator}
                                                              onChange={handleChange}
                                                            >
                                                                <option disabled value="">Válassz</option>
                                                                <option value="Igen">Igen</option>
                                                                <option value="Nem">Nem</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="area"
                                                                   className="form-label">Lakás alapterülete</label>
                                                            <select
                                                              name="area"
                                                              className="form-control"
                                                              value={formData.area}
                                                              onChange={handleChange}
                                                            >
                                                                <option disabled value="">Válassz</option>
                                                                <option value="30nm alatt">30nm alatt</option>
                                                                <option value="30nm - 50nm">30nm - 50nm</option>
                                                                <option value="50nm felett">50nm felett</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="parking"
                                                                   className="form-label">Parkolás megoldható a hát
                                                                előtt?</label>
                                                            <select
                                                              name="parking"
                                                              className="form-control"
                                                              value={formData.parking}
                                                              onChange={handleChange}
                                                            >
                                                                <option disabled value="">Válassz</option>
                                                                <option value="Igen">Igen</option>
                                                                <option value="Nem">Nem</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="boxes"
                                                                   className="form-label">Dobozok / zsákok
                                                                száma:</label>
                                                            <input name="boxes" type="number" className="form-control"
                                                                   placeholder="pl.: 10 db"
                                                                   id="boxes"
                                                                   value={formData.boxes}
                                                                   onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="area"
                                                                   className="form-label">Hol hallottál rólunk?</label>
                                                            <select
                                                              name="utm"
                                                              className="form-control"
                                                              value={formData.utm}
                                                              onChange={handleChange}
                                                            >
                                                                <option value="">Válassz</option>
                                                                <option value="Facebook">Facebook</option>
                                                                <option value="Google">Google</option>
                                                                <option value="Ajánlás">Ajánlás</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Az ajanlo nevere a tovabbajanlasi visszateriteshez van szukseg,
                                                        ezert csak akkor kerdezzuk meg, ha "Ajanlas"-t valasztott. */}
                                                    {formData.utm === "Ajánlás" && (
                                                      <div className="col-lg-8 col-md-12">
                                                          <div className="form-group mb-3">
                                                              <label htmlFor="referred_by"
                                                                     className="form-label">Ki ajánlott minket?</label>
                                                              <input name="referred_by" type="text"
                                                                     className="form-control"
                                                                     placeholder="Az ajánló neve vagy telefonszáma"
                                                                     id="referred_by"
                                                                     value={formData.referred_by}
                                                                     onChange={handleChange}
                                                              />
                                                              <small style={{color: '#777'}}>
                                                                  Sikeres megbízás után 5 000 Ft-ot adunk vissza az
                                                                  ajánlónak.
                                                              </small>
                                                          </div>
                                                      </div>
                                                    )}
                                                    <div className="col-lg-12">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="message"
                                                                   className="form-label">Bútorok száma / mérete,
                                                                egyéb:</label>
                                                            <textarea name="message" className="form-control" rows={3}
                                                                      placeholder="Üzenet" defaultValue={""}
                                                                      id="message"
                                                                      value={formData.message}
                                                                      onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group mb-3">
                                                            <div className="checkbox-wrapper">
                                                            <input type="checkbox" id="checkbox"
                                                                       name={"terms_and_conditions"}
                                                                       checked={formData.terms_and_conditions}
                                                                       onChange={(event) => {
                                                                           formTracking.field('terms_and_conditions', event.target.checked);
                                                                           setFormData({
                                                                               ...formData,
                                                                               ['terms_and_conditions']: event.target.checked
                                                                           });
                                                                       }}/>
                                                                <label style={{textTransform: 'none'}}
                                                                       htmlFor="checkbox" className="checkbox-label">
                                                                    <span className="checkbox-custom"></span>
                                                                    <span className="checkbox-text">Megismertem és elfogadom az <a
                                                                      href="/aszf">Általános Szerződési Feltételeket</a> és az <a
                                                                      href="/adatvedelem">Adatvédelmi Szabályzatot!</a></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <button
                                                          onClick={handleSubmit}
                                                          className="btn-half site-button">
                                                            <span>Küldés</span><em/>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 site-bg-dark">
                                        <div className="contact-info bg-no-repeat bg-bottom-left"
                                             style={{backgroundImage: `url(${publicUrlFor('/assets/images/background/contact-bg.png')})`}}>
                                            {/* TITLE START*/}
                                            <div className="section-head-small white mb-4">
                                                <h3 className="wt-title">Kapcsolat</h3>
                                            </div>
                                            {/* TITLE END*/}
                                            <div className="contact-info-section">
                                                <div className="c-info-column mt-5">
                                                    <div className="c-info-icon fa fa-mobile-phone custome-size"><span/>
                                                    </div>
                                                    {/* Az ikon 50px magas, es az oszlop sajat 20px-es felso
                                                        margojatol indul - ugyanonnan, ahonnan ez a blokk is.
                                                        Igy az elso szam az ikon tetejevel, a masodik az aljaval
                                                        zar egy vonalba. */}
                                                    <div style={{
                                                        minHeight: '50px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <p style={{margin: 0}}><a
                                                          onClick={() => handleClickPhone('06706251650')}
                                                          href="tel:06706251650">+36 70 625 1650</a></p>
                                                        <p style={{margin: 0}}><a
                                                          onClick={() => handleClickPhone('06704093379')}
                                                          href="tel:06704093379">+36 70 409 3379</a></p>
                                                    </div>
                                                </div>
                                                <div className="c-info-column">
                                                    <div className="c-info-icon fa fa-envelope-o"><span/></div>
                                                    <p className="mt-3"><a href="mailto:hello@teleportkoltoztetes.hu">hello@teleportkoltoztetes.hu</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}